import {
  IQualificationItem,
  IPsyRating,
  ISessionProfileData,
} from '@/modules/Attendance/types'

export class Medic {
  private _price: number
  // eslint-disable-next-line no-useless-constructor
  constructor(
    private readonly _id: number,
    private readonly _name: string,
    private readonly _photo?: string,
    private readonly _speciality?: string,
    private readonly _council?: string,
    private _specialityId?: string | number,
    private readonly _qualifications?: IQualificationItem[],
    private readonly _about?: string,
    private readonly _ratings?: IPsyRating,
    private readonly _themes?: string[],
    private readonly _title?: string,
    private readonly _session?: ISessionProfileData,
    private readonly _city?: string,
    private readonly _state?: string,
    private readonly _isCorporateProfessional?: boolean,
    private readonly _professionalQualification?: string,
    private readonly _approach?: string,
  ) {}

  get id(): number {
    return this._id
  }

  get name(): string {
    return this._name
  }

  get photo(): string {
    return this._photo
  }

  get price(): number {
    return this._price
  }

  set price(value: number) {
    this._price = value
  }

  get speciality(): string {
    return this._speciality
  }

  get council(): string {
    return this._council
  }

  get specialityId(): string | number {
    return this._specialityId
  }

  set specialityId(value: string | number) {
    this._specialityId = value
  }

  get qualifications(): IQualificationItem[] {
    return this._qualifications
  }

  get about(): string {
    return this._about
  }

  get ratings(): IPsyRating {
    return this._ratings
  }

  get themes(): string[] {
    return this._themes
  }

  get title(): string {
    return this._title
  }

  get session(): ISessionProfileData {
    return this._session
  }

  get city(): string {
    return this._city
  }

  get state(): string {
    return this._state
  }

  get professionalQualification(): string | null {
    return this._professionalQualification
  }

  get isCorporateProfessional(): boolean {
    return this._isCorporateProfessional
  }

  get approach(): string {
    return this._approach
  }
}
